import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../config/firebaseConfig";

const Add = ({ users, setUsers, setIsAdding, getUsers, editingUser }) => {
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [cardType, setCardType] = useState("new-user");

  // ✅ Als er een editingUser is, vul de velden vooraf in
  useEffect(() => {
    if (editingUser) {
      setFirstName(editingUser.firstname);
      setLastName(editingUser.lastname);
      setEmail(editingUser.email);
      setRole(editingUser.role);
      setCardType("edit-user"); // 👈 type aangeven
    } else {
      setCardType("new-user"); // 👈 type aangeven
    }
  }, [editingUser]);

  const handleAddOrUpdate = async (e) => {
    e.preventDefault();

    if (!firstname || !lastname || !email || !role) {
      return Swal.fire({
        icon: "warning",
        title: "Fout!",
        text: "Alle velden zijn verplicht.",
        showConfirmButton: true,
      });
    }

    try {
      if (editingUser) {
        // ✅ Bestaande user updaten
        const userRef = doc(db, "users", editingUser.id);
        await updateDoc(userRef, {
          firstname,
          lastname,
          role,
        });
        Swal.fire({
          icon: "success",
          title: "Bijgewerkt",
          text: `${firstname} ${lastname} is bijgewerkt.`,
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        // ✅ Nieuwe user toevoegen
        const newUser = {
          firstname,
          lastname,
          email,
          role,
        };
        await setDoc(doc(db, "users", email), newUser);
        Swal.fire({
          icon: "success",
          title: "Toegevoegd",
          text: `${firstname} ${lastname} is toegevoegd.`,
          showConfirmButton: false,
          timer: 1500,
        });
      }

      setUsers(users);
      setIsAdding(false);
      getUsers();
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Fout!",
        text: "Er ging iets mis bij opslaan.",
      });
    }
  };

  return (
    <>
      <form className="new-user-form" onSubmit={handleAddOrUpdate}>
        <label htmlFor="firstName">Voornaam</label>
        <input
          id="voornaam"
          type="text"
          name="voornaam"
          value={firstname}
          autoComplete="off"
          onChange={(e) => setFirstName(e.target.value)}
        />
        <div></div>

        <label htmlFor="lastName">Achternaam</label>
        <input
          id="achternaam"
          type="text"
          name="achternaam"
          value={lastname}
          autoComplete="off"
          onChange={(e) => setLastName(e.target.value)}
        />
        <div></div>

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="text"
          name="email"
          value={email}
          autoComplete="off"
          onChange={(e) => setEmail(e.target.value)}
          disabled={!!editingUser} // ✅ Niet bewerkbaar bij edit
        />
        <div></div>

        <label htmlFor="role">Rol</label>
        <select
          id="role"
          name="role"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="">Selecteer rol</option>
          <option value="User">User</option>
          <option value="Admin">Admin</option>
        </select>
        <div></div>
        <div className="button-group">
          <button className="save-button" type="submit">
            Opslaan
          </button>
          <button
            className="cancel-button"
            type="button"
            onClick={() => setIsAdding(false)}
          >
            Annuleren
          </button>
        </div>
      </form>
    </>
  );
};

export default Add;
